// ABOUTME: Pure helpers for the relation news editor modal.
// ABOUTME: Builds the API payload and decides whether publish is allowed.

export const AUDIENCE_ALL = "all";
export const AUDIENCE_SPECIFIC = "specific";

// An empty relationIds means "every relation of the chosen warehouses", so the "all" audience
// always sends an empty list regardless of what was picked before switching back.
export const buildRelationNewsPayload = ({ title, body, warehouseIds, audience = AUDIENCE_ALL, relationIds }) => ({
    title: title?.trim() || "",
    body: body ?? null,
    warehouseIds: warehouseIds ?? [],
    relationIds: audience === AUDIENCE_SPECIFIC ? (relationIds ?? []) : [],
});

export const canPublish = ({ title, body, warehouseIds, audience = AUDIENCE_ALL, relationIds }) =>
    Boolean(title?.trim()) &&
    Boolean(body) &&
    (warehouseIds?.length ?? 0) > 0 &&
    (audience !== AUDIENCE_SPECIFIC || (relationIds?.length ?? 0) > 0);

// Derives the editor's audience state from a saved message.
export const audienceFromNewsItem = (newsItem) =>
    (newsItem?.relations?.length ?? 0) > 0 ? AUDIENCE_SPECIFIC : AUDIENCE_ALL;

// Only relations of the chosen warehouses can ever read the message, so those are the only ones
// worth offering. A relation without a warehouse reads the news of every warehouse (common when an
// environment has a single warehouse), so it is offered as soon as any warehouse is chosen.
export const relationsForWarehouses = (relations, warehouseIds) => {
    const ids = warehouseIds ?? [];
    if (ids.length === 0) return [];
    return (relations ?? []).filter((r) => !r.warehouseId || ids.includes(r.warehouseId));
};

// Drops picked relation ids that are no longer offered after the warehouse selection changed.
export const pruneRelationIds = (relationIds, relations, warehouseIds) => {
    const allowed = new Set(relationsForWarehouses(relations, warehouseIds).map((r) => r.id));
    return (relationIds ?? []).filter((id) => allowed.has(id));
};
